/** Follow-up chips shown under the "analysis finished" bubble. */
export const FOLLOW_UP_SUGGESTIONS: Record<string, string[]> = {
  vegetation_index: [
    'Summarize the main vegetation trend',
    'Which months had the lowest NDVI?',
    'Compare this with the previous year',
  ],
  air_quality: [
    'Which pollutant is the biggest concern?',
    'How does this compare to WHO guidelines?',
    'Show the same analysis for last year',
  ],
  water_quality: [
    'Explain what these water indices mean',
    'Is the water quality improving or declining?',
    'Run this for a nearby lake',
  ],
  video_animation: [
    'Describe the main changes in the animation',
    'Make a longer time range',
    'Create the same animation for another city',
  ],
  business_location: [
    'Give me the addresses of the top five',
    'Which one has the best rating?',
    'Search a wider radius',
  ],
  weather_forecast: [
    'Will it rain this week?',
    'Compare with the seasonal average',
    'Forecast for a nearby city',
  ],
  default: [
    'Summarize the key findings',
    'Explain how to interpret these results',
    'Run the same analysis for another location',
  ],
};

export const SAMPLE_QUESTIONS = [
  { text: 'NDVI analysis near Los Angeles, California from 2023 to 2024', domain: 'Vegetation' },
  { text: 'Air pollution level in Holcim cement factory in Beocin, Serbia between Jan 2024 till August 2024', domain: 'Air Quality' },
  { text: 'Water quality assessment of Lake Erie', domain: 'Water Quality' },
  { text: 'Find coffee shops in downtown San Francisco', domain: 'Location' },
  { text: 'Weather forecast for New York City', domain: 'Weather' },
  { text: 'Vegetation change in Fazenda Rio Preto I farm in Mato Grosso, Brazil from 2019 vs 2024', domain: 'Deforestation' },
  { text: 'Satellite timelapse animation of Dubai airport from March 2025 to Jun 2025', domain: 'Animation' },
  { text: 'NO2 air pollution in Delhi, India for 2024', domain: 'Air Quality' },
  { text: 'Water quality of Lake Victoria near Kisumu, Kenya in 2024', domain: 'Water Quality' },
  { text: 'NDVI trend for vineyards in Napa Valley, California during 2024', domain: 'Vegetation' },
  { text: 'Timelapse of forest loss around Porto Velho, Brazil from 2020 to 2024', domain: 'Animation' },
  { text: 'Find pharmacies near Shibuya Station, Tokyo', domain: 'Location' }
];
